import { __read } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { FaTimes } from 'react-icons/fa';
export var Modal = function (props) {
    var isShowing = props.isShowing, hide = props.hide, children = props.children, footer = props.footer, size = props.size, hideFooter = props.hideFooter, hideHeader = props.hideHeader, bodyClasses = props.bodyClasses, header = props.header, hideClose = props.hideClose;
    var modalSize = size || 'lg';
    var _a = __read(React.useState(false), 2), hideIsTriggered = _a[0], setHideIsTriggered = _a[1];
    var node = React.useRef(null);
    var onKeyPressed = function (e) {
        if (e.key === 'Escape' && props.hide && !hideIsTriggered) {
            e.preventDefault();
            setHideIsTriggered(true);
            document.addEventListener('keydown', onKeyPressed);
            props.hide();
        }
    };
    var handleClickOutside = function (e) {
        if (node && node.current && node.current.contains(e.target)) {
            return;
        }
        if (node && node.current && e.target.classList.contains('ignore-clickoutside')) {
            return;
        }
        // outside click 
        props.hide && props.hide();
    };
    React.useEffect(function () {
        // add when mounted
        document.addEventListener('keydown', onKeyPressed);
        document.addEventListener("mousedown", handleClickOutside);
        // return function to be called when unmounted
        return function () {
            document.removeEventListener('keydown', onKeyPressed);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
    if (isShowing) {
        return ReactDOM.createPortal(React.createElement(React.Fragment, null,
            React.createElement("div", { className: "modal-wrapper " + modalSize + (isShowing ? ' showModal' : ' hideModal') },
                React.createElement("div", { className: "modal " + (isShowing ? "showModal" : "hideModal"), ref: node },
                    !hideHeader &&
                        React.createElement("div", { className: "modal-header" },
                            header,
                            !hideClose &&
                                React.createElement("div", { className: "modal-header__close", onClick: hide },
                                    React.createElement(FaTimes, null))),
                    hideHeader && !hideClose &&
                        React.createElement("div", { className: "modal-header__close", onClick: hide },
                            React.createElement(FaTimes, null)),
                    React.createElement("div", { className: "modal-body" + (bodyClasses ? ' ' + bodyClasses : '') }, children && children),
                    !hideFooter &&
                        React.createElement("div", { className: "modal-footer" }, footer && footer)))), document.getElementById('root'));
    }
    return null;
};
//# sourceMappingURL=Modal.js.map